import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import { EllipsisMenuProps } from './common'

import ModalBody from 'components/Luxkit/Modal/ModalBody'
import ModalFooter from 'components/Luxkit/Modal/ModalFooter'
import ModalHeader from 'components/Luxkit/Modal/ModalHeader'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'

export const ModalMenuContent = styled.div`
  padding-left: ${rem(8)};
  padding-right: ${rem(8)};
`

export default function MenuModal(props: EllipsisMenuProps) {
  const { title, subtitle, bodyContent, footerContent } = props
  const { closeModal, goBack } = useModalCallbacks()

  return (
    <>
      <ModalHeader
        title={title}
        subtitle={subtitle}
        onCloseButtonClick={closeModal}
        onBackButtonClick={goBack}
      />
      <ModalBody>
        <ModalMenuContent>{bodyContent}</ModalMenuContent>
      </ModalBody>
      <ModalFooter>{footerContent}</ModalFooter>
    </>
  )
}
